import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  agreeButtonLabel: {
    id: 'authoring.agreement-gated-feature.agree',
    defaultMessage: 'Agree',
    description: 'The label for the Agree button on an alert asking users to agree with terms.',
  },
  learnMoreLinkLabel: {
    id: 'authoring.agreement-gated-feature.learn-more',
    defaultMessage: 'Learn more',
    description: 'The label for a "learn more" link on an alert asking users to agree with terms.',
  },
});

export default messages;
